import React, { Fragment } from 'react';
import AboutPage from './About2.png'

export const About = () => {
  return (
    <img className="img-fluid mr-sm-3 mr-0" src={AboutPage} alt="" />
  )
}
export default About
